import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const BatteryNotice = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('battery_item4'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 15, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('battery_notice_detail')}</span>
            </div>
            <div style={{ height: 20 }} />
        </div>
    </div>
}

export default BatteryNotice